import { useAuth0 } from '@auth0/auth0-react';
import { useNavigate } from 'react-router-dom';
import { useEffect, useRef } from 'react';
import { useRollbar } from '@rollbar/react';
import { PageLoader } from '../PageLoader';
import { useLocalStorage } from '../utils/useLocalStorage';
import { getDefaultRoute } from '../auth/getDefaultRoute';

export default function Index() {
  const auth0 = useAuth0();
  const [accessToken = ''] = useLocalStorage('accessToken', '');

  const navigate = useNavigate();

  const rollbar = useRollbar();
  const hasRedirectedRef = useRef(false);

  if (auth0.error) {
    console.error(`Auth0 error: ${auth0.error.message}`);
  }

  useEffect(() => {
    if (hasRedirectedRef.current) return;
    if (accessToken && auth0.isAuthenticated && !auth0.isLoading) {
      if (process.env.NODE_ENV === 'production') {
        // update rollbar configuration
        rollbar.configure({
          payload: {
            person: {
              id: auth0.user.sub,
              email: auth0.user.email,
            },
          },
        });
      }

      // If the user just completed Auth0 login with a pending deep-link
      // (stashed by Auth0Provider.onRedirectCallback), navigate there instead
      // of the permission-based default.
      const pendingDeepLink = sessionStorage.getItem('auth0DeepLinkReturnTo');
      if (pendingDeepLink) {
        sessionStorage.removeItem('auth0DeepLinkReturnTo');
        hasRedirectedRef.current = true;
        navigate(pendingDeepLink.replace(/^#/, ''), { replace: true });
        return;
      }

      hasRedirectedRef.current = true;
      const defaultRoute = getDefaultRoute();
      if (defaultRoute) {
        navigate(defaultRoute);
      } else {
        console.error('No menu permissions found');
        navigate('/no-access');
      }
    }
  });

  // log matador app version once
  useEffect(() => {
    console.log('Matador Version: ', process.env.VERSION);
  }, []);

  if (auth0.isLoading) return <div>Loading...</div>;
  if (auth0.error) return <div>{auth0.error.message}</div>;

  return <PageLoader />;
}
